import React from "react";

import {useLevelRealtimeSubV2} from "~/api/hooks/useLevelV2";
import {useGroupSession} from "~/contexts/session/GroupSessionProvider";
import {usePlayerActions} from "~/hooks/usePlayerActions";

import useZoomControls from "../../../hooks/useZoomControls";
import CoopHtml from "./CoopHtml";

const CoopHtmlWrapper: React.FC = () => {
  const {sessionData} = useGroupSession();
  useLevelRealtimeSubV2({id: sessionData?.current_round?.levelId});
  useZoomControls();
  usePlayerActions();

  return (
    <>
      <CoopHtml />
    </>
  );
};

export default CoopHtmlWrapper;
